// extracted by mini-css-extract-plugin
export default {"title1":"BannerTitle_title1__8uR+L","title2":"BannerTitle_title2__ni3BH"};